import { render, staticRenderFns } from "./CriticalFormatsPrintModal.vue?vue&type=template&id=94c88a28&scoped=true"
import script from "./CriticalFormatsPrintModal.vue?vue&type=script&lang=js"
export * from "./CriticalFormatsPrintModal.vue?vue&type=script&lang=js"
import style0 from "./CriticalFormatsPrintModal.vue?vue&type=style&index=0&id=94c88a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c88a28",
  null
  
)

export default component.exports